<div class="wrap-x overflow-hidden multi-column-banner animation-long"
     [class.animation-reveal]="canAnimate"
     [gsap]
     [gsapOff]="!canAnimate"
     [scrollTrigger]="{ start: '50% bottom', end: '100% top', toggleClass: 'is-animate', once: true }">
    <div [ngClass]="['p-r-' + (component.wrap_padding || 0), 'p-l-' + (component.wrap_padding || 0)]">
        @if (!client.isS || (client.isS && !component.carousel)) {
        <div [grid]="!client.isS ? component.items.length : 1"
             [gridColumnGap]="component.grid_gap"
             [gridRowGap]="component.grid_gap">
            @for (item of component.items; track $index) {
            <ng-container *ngTemplateOutlet="sliderItem; context: { $implicit: item, component: component}" />
            }
        </div>
        }
        @if (client.isS && component.carousel) {
        <!-- base size for S is 4px so `margin = component.grid_gap * 4` -->
        <carousel [slidesPerView]="component.carousel_auto_width ? 'auto' : 2"
                  [slidesPerGroup]="1"
                  [spaceBetween]="component.grid_gap * 4"
                  [loop]="!!component.carousel_loop"
                  [loopAdditionalSlides]="1"
                  [nested]="!!component.carousel_nested"
                  [style.--swiper-slide-width.px]="component.carousel_auto_width ? component.carousel_width : null">
            @for (item of component.items; track $index) {
            <ng-template carouselSlide>
                <ng-container *ngTemplateOutlet="sliderItem; context: { $implicit: item, component: component}">
                </ng-container>
            </ng-template>
            }
        </carousel>
        }
    </div>
</div>

<ng-template #sliderItem
             let-item
             let-component="component">
    <div>
        <div class="ratio-3-4">
            <href [link]="item.cta_link"
                  [hrefClass]="'rf'">
                <div class="rf overflow-hidden">

                    <!-- placeholder -->
                    @if (!item.image && item.video_id) {
                    <shell />
                    }

                    <!-- image -->
                    @if (item.image) {
                    <img class="z-2 animation-zoom-in animation-on-hover"
                         [dfImage]="item.image"
                         [priority]="component.cwvLoading === 'eager' || component.cwvPriority"
                         ratio="3/4"
                         fill>
                    }

                    <!-- video -->
                    @if (item.video_id) {
                    <local-vimeo-player class="rf z-3"
                                        [video-id]="item.video_id"
                                        [autoplay-in-viewport]="true"
                                        [background]="true"
                                        [controls]="false"
                                        [muted]="true"
                                        [loop]="true" />
                    }

                    <!-- button -->
                    @if (item.cta_text) {
                    <div class="pos-absolute bottom-2 left-3 z-4">
                        <p class="p-b-2"
                           [ngClass]="item.cta_title_text_color || ''"
                           *iCms="'cta_title' of item"></p>
                        <button [ngClass]="item.cta_style || 'button-inline'"
                                type="button">
                            <span [ngClass]="item.cta_text_color || ''"
                                  *iCms="'cta_text' of item"></span>
                            @if (item.display_arrow) {
                            <span [ngClass]="item.cta_text_color || ''"
                                  class="p-l-1 icon-arrow-forward"></span>
                            }
                        </button>
                    </div>
                    }
                </div>
            </href>
        </div>
        @if (item.title || item.cta_text_1) {
        <div [ngClass]="item.text_align || ''"
             class="p-t-2 p-l-1-l p-l-1-m p-l-3-s p-r-3-s">
            <p class="p-b-2 h3"
               [ngClass]="item.title_text_color || ''"
               *iCms="'title' of item"></p>
            <href [link]="item.cta_link_1">
                <button [ngClass]="[item.cta_style_1 || 'button-inline', item.cta_text_1_color || '']"
                        type="button">
                    <span [ngClass]="item.cta_text_1_color || ''"
                          *iCms="'cta_text_1' of item"></span>
                    @if (item.display_arrow_1) {
                    <span [ngClass]="item.cta_text_1_color || ''"
                          class="p-l-1 icon-arrow-forward"></span>
                    }
                </button>
            </href>
        </div>
        }
    </div>
</ng-template>